// Guardar token en localStorage
export const setToken = (token) => {
  localStorage.setItem('token', token);
};

// Obtener token del localStorage
export const getToken = () => {
  return localStorage.getItem('token');
};

// Verificar si el usuario está autenticado (solo verifica si existe un token)
export const isAuthenticated = () => {
  const token = getToken();
  return !!token;
};

// Guardar información del usuario
export const setUser = (user) => {
  localStorage.setItem('user', JSON.stringify(user));
};

// Obtener información del usuario
export const getUser = () => {
  const user = localStorage.getItem('user');
  return user ? JSON.parse(user) : null;
};

// Limpiar datos de autenticación
export const clearAuth = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
};


